import React, {useEffect, forwardRef} from 'react';

import {parseJSFromHTML} from '@optimaxdev/utils';
import {setContext} from '@sentry/react';

type PropsType = {
    html: string;
    tag?: keyof JSX.IntrinsicElements;
    [key: string]: any;
};

/**
 * Insert HTML into the component, with working execution of internal scripts
 */
export const InnerHtml = React.memo<PropsType>(
    forwardRef<HTMLInputElement, PropsType>(({html, tag = 'div', ...props}, ref) => {
        useEffect(() => {
            const code = html ? parseJSFromHTML(html) : '';

            try {
                if (code) window.eval(code);
            } catch (e) {
                console.error('Error in parsed script', e); // eslint-disable-line no-console
                setContext('Script with error', {script: code});
            }
        }, [html]);

        return React.createElement(tag, {
            dangerouslySetInnerHTML: {__html: html},
            ref,
            ...props,
        });
    }),
);

InnerHtml.displayName = 'InnerHtml';
